import { Fragment } from 'react';
import classNames from 'classnames';
import { motion } from 'motion/react';
import Button from '@/shared/components/flip-ui-kit/Button';

export type NavbarDropdownItem = {
  separator?: React.ReactNode;
  content: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
};

type NavbarDropdownProps = {
  title: React.ReactNode;
  items: (NavbarDropdownItem | null)[];
  isActive: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
};

const animate = {
  enter: {
    opacity: 1,
    scale: 1,
    y: '0px',
    transition: {
      duration: 0.15,
    },
    display: 'block',
  },
  exit: {
    opacity: 0,
    scale: 1,
    y: '-8px',
    transition: {
      duration: 0.15,
    },
    transitionEnd: {
      display: 'none',
    },
  },
};

const NavbarDropdown = ({
  title,
  items,
  isActive,
  onMouseEnter,
  onMouseLeave,
}: NavbarDropdownProps) => (
  <motion.div onMouseLeave={onMouseLeave} className="relative">
    <motion.div
      onMouseEnter={onMouseEnter}
      className={classNames('flex cursor-default items-center', isActive && 'text-cf-white')}
    >
      {title}
    </motion.div>
    <motion.div
      initial="exit"
      animate={isActive ? 'enter' : 'exit'}
      variants={animate}
      className="absolute right-0 z-20 pt-2"
    >
      <div className="flex w-[188px] flex-col space-y-2 rounded-md border border-cf-gray-4 bg-cf-gray-3-5 p-2.5 text-14 text-cf-white">
        {items.map(
          (item, index) =>
            item && (
              // eslint-disable-next-line react/no-array-index-key
              <Fragment key={index}>
                {item.separator}
                {item.onClick ? (
                  <Button
                    type="link-secondary"
                    onClick={item.onClick}
                    className="!justify-start !p-0"
                    size="small"
                    disabled={item.disabled}
                  >
                    {item.content}
                  </Button>
                ) : (
                  <div className="min-h-[32px]">{item.content}</div>
                )}
              </Fragment>
            ),
        )}
      </div>
    </motion.div>
  </motion.div>
);

export default NavbarDropdown;
